"use strict";
import React from "react";
import Rectangle from "./rectangle";
import { getDisplayName } from "./utils";
import Vector from "immutable-vector2d";
import "../../api/api";
const StampElement = (props) => {
  return /* @__PURE__ */ React.createElement("g", { transform: `translate(${props.x},${props.y})` }, /* @__PURE__ */ React.createElement(
    "image",
    {
      x: Math.min(0, props.width),
      y: Math.min(0, props.height),
      width: Math.abs(props.width),
      height: Math.abs(props.height),
      xlinkHref: props.annotationStampUrl,
      preserveAspectRatio: "none",
      style: { cursor: props.annotating ? "move" : "default" }
    }
  ), /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0
    }
  ));
};
StampElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
StampElement.typeID = "Stamp";
StampElement.displayName = getDisplayName(StampElement);
StampElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default StampElement;
